import type { HostTenantListItem } from '../../tenants/api/tenants';
import { normalizeTenantStatus } from '../../tenants/api/tenants';

/** Primary contact email cannot change once tenant or contact is active (onboarded). */
export function isPrimaryContactEmailLocked(tenant: HostTenantListItem): boolean {
  if (normalizeTenantStatus(tenant.status) === 'Active') {
    return true;
  }

  return tenant.primaryContactAccountStatus === 'Active';
}

export function canResendTenantOnboarding(tenant: HostTenantListItem): boolean {
  const status = normalizeTenantStatus(tenant.status);

  if (status === 'Requested' || status === 'Rejected' || status === 'Expired') {
    return false;
  }

  return tenant.primaryContactAccountStatus === 'Pending';
}
